import {NgModule} from '@angular/core';
import {TranslatePipe, TranslateService, provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {SessionStorageService} from 'ngx-webstorage';

// export function appInitializerFactory(translateService: TranslateService): () => Promise<any> {
//   return () => {
//     translateService.setDefaultLang('en');
//     return translateService.use('en').toPromise();
//   };
// }

@NgModule({
  imports: [TranslatePipe],
  exports: [TranslatePipe],
  providers: [
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/content/i18n/',
        suffix: '.json?',
        enforceLoading: true
      })
    })
  ]
})
export class TranslationModule {
  constructor(
    private readonly translateService: TranslateService,
    private readonly sessionStorageService: SessionStorageService
  ) {
    // if user have changed language and navigates away from the application and back to the application then use previously choosed language
    const langKey = sessionStorageService.retrieve('locale') ?? 'en';
    translateService.use(langKey);
  }
}
